const removeSession = () => {
        sessionStorage.removeItem('currentPage');
        sessionStorage.removeItem('list');
        sessionStorage.removeItem('details');
        sessionStorage.removeItem('totalPage');
        sessionStorage.removeItem('navigateType');
        sessionStorage.removeItem('scrollPosition');
}

export default removeSession;